module.exports = __webpack_public_path__ + "img/game_main_pc_208_off.76343ae0.png";